import React from 'react';
import { useAsync } from 'react-use';
import { withTheme } from '@emotion/react';
import { Theme } from '@theme/base';
import { Testimonial } from '@model/iceberg';
import { TestimonialsApi } from '@model/iceberg/service/testimonials';
import { Carousel } from './carousel';

export interface TestimonialsProps {
  testimonials?: Array<Testimonial>;
  id?: string;
  timeout: number;
  theme?: Theme;
}

export const TestimonialsComponent = (props: TestimonialsProps) => {
  const { timeout, testimonials } = props;
  const testimonialResponse = useAsync(async () => {
    if (testimonials) return testimonials;
    const api: TestimonialsApi = new TestimonialsApi();
    return await api.get();
  });
  if (testimonialResponse.error || testimonialResponse.loading || !testimonialResponse.value) return null;

  return <Carousel testimonials={testimonialResponse.value} timeout={timeout} />;
};

export const Testimonials = withTheme(TestimonialsComponent);
